export type ProductHierarchySelections = {
  businessGroup?: string;
  productLine?: string;
  productGroup?: string;
  productClass?: string;
};

const PARAMS = {
  businessGroup: 'business_group',
  productLine: 'product_line',
  productGroup: 'product_group',
  productClass: 'product_class',
} as const;

export function readSelectionsFromSearchParams(sp: URLSearchParams): ProductHierarchySelections {
  const bg = sp.get(PARAMS.businessGroup) || undefined;
  const pl = sp.get(PARAMS.productLine) || undefined;
  const pg = sp.get(PARAMS.productGroup) || undefined;
  const pc = sp.get(PARAMS.productClass) || undefined;

  return {
    businessGroup: bg || undefined,
    productLine: pl || undefined,
    productGroup: pg || undefined,
    productClass: pc || undefined,
  };
}

export function writeSelectionsToSearchParams(sp: URLSearchParams, sel: ProductHierarchySelections) {
  sp.delete(PARAMS.businessGroup);
  sp.delete(PARAMS.productLine);
  sp.delete(PARAMS.productGroup);
  sp.delete(PARAMS.productClass);

  if (sel.businessGroup) sp.set(PARAMS.businessGroup, sel.businessGroup);
  if (sel.productLine) sp.set(PARAMS.productLine, sel.productLine);
  if (sel.productGroup) sp.set(PARAMS.productGroup, sel.productGroup);
  if (sel.productClass) sp.set(PARAMS.productClass, sel.productClass);
}
